export const ADMIN_ROLE = 'Administrator';
export const CURRENT_USER_STRING = 'currentUser';
export const Auth = {
    grantTypeForLogin: 'password',
    grantTypeForRefreshToken: 'refresh_token',
    grantTypeForSSO: 'ad',
    grantTypeForVerificationCode: 'otp',
    grantTypeForGeoOne: 'goemail',
    clientId: 'ro.client',
    clientSecret: 'secret',

}
export const OWNER_ROLE = 'Owner';
export const Super_User_Emissions = 'Super User - Emissions';
export const Scorpio_Pool_Owner = 'User - Scorpio Pool Owner';
export const InterceptorSkipHeader = 'X-Skip-Interceptor';
